import { useLocation, useNavigate } from 'react-router-dom'

import { track } from '@amplitude/analytics-browser'
import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import useRevokeAccess from 'modules/billing/hooks/useRevokeAccess'
import { useCompanies } from 'modules/factorial_id/hooks/useCompanies'

const TrialExpiredModal = ({ isBecome = false }: { isBecome: boolean }) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { pathname } = useLocation()
  const { companies } = useCompanies()
  const { company } = useCurrentSession()
  const { revokeAccess, loading: revokingAccess } = useRevokeAccess()

  const handleChooseYourPlan = () => {
    track(trackingEvents.billing.goToPricingPlans, {
      page_path: pathname,
      from: 'trial_expired_modal',
    })
    navigate(`/${navigation.upgradePlan.path}`)
  }

  const handleSwitchCompany = async () => {
    try {
      if (company?.id) {
        await revokeAccess(company.id)
      }
    } catch {
    } finally {
      window.location.href = navigation.authentication.company_selector.fullPath()
    }
  }

  const handleCloseModal = () => {
    alert(i18n.t('trial_expired_modal.become.alert'))
  }

  const features = [
    {
      title: i18n.t('trial_expired_modal.admin.content.improve_performance.title'),
      content: i18n.t('trial_expired_modal.admin.content.improve_performance.content'),
    },
    {
      title: i18n.t('trial_expired_modal.admin.content.manage_absences.title'),
      content: i18n.t('trial_expired_modal.admin.content.manage_absences.content'),
    },
    {
      title: i18n.t('trial_expired_modal.admin.content.automate_tasks.title'),
      content: i18n.t('trial_expired_modal.admin.content.automate_tasks.content'),
    },
    {
      title: i18n.t('trial_expired_modal.admin.content.business_insights.title'),
      content: i18n.t('trial_expired_modal.admin.content.business_insights.content'),
    },
  ]

  const UPGRADE_PLAN_EXCLUDED_PAGES = ['/upgrade-plan', '/settings', '/personal-settings']

  const isTrialExpiredModalVisible = !UPGRADE_PLAN_EXCLUDED_PAGES.some((url) =>
    pathname.includes(url)
  )

  if (!isTrialExpiredModalVisible) {
    return null
  }

  const hasMultipleCompanies = companies.length > 1

  track(trackingEvents.billing.viewedLockModal, {
    viewed_by: 'admin',
  })

  return (
    <>
      <Modal
        locked={!isBecome}
        onClose={handleCloseModal}
        illustration="fireworks"
        title={i18n.t('trial_expired_modal.admin.title')}
        description={i18n.t('trial_expired_modal.admin.subtitle')}
        footer={
          <>
            {hasMultipleCompanies && (
              <Button onClick={handleSwitchCompany} disabled={revokingAccess}>
                {i18n.t('trial_expired_modal.admin.leave_trial')}
              </Button>
            )}
            <Button type="upgrade" onClick={handleChooseYourPlan}>
              {i18n.t('trial_expired_modal.admin.choose_your_plan')}
            </Button>
          </>
        }
      >
        <Box gap="s12">
          {features.map((feature) => {
            return (
              <Box key={feature.title} flexDirection="row" gap="s8">
                <Box>
                  <Icon.Medium icon="check-circle" color="viridian1000" />
                </Box>
                <Text.Normal>
                  <Text.Normal weight="bold">{feature.title}</Text.Normal> {feature.content}
                </Text.Normal>
              </Box>
            )
          })}
        </Box>
      </Modal>
    </>
  )
}

export default observer(TrialExpiredModal)
